import { getSharedState } from "./windowBus";

// AddScreen.tsx (the dedicated "/add" destination page) needs to trigger
// the native file picker once a destination album is chosen, but
// UploadWidget.tsx owns the actual <input type=file>/XHR upload machinery
// - same cross-component "register once, call from anywhere" shape as
// albumsBridge.ts/autolockBridge.ts, just the opposite direction (there,
// something else registers for React to call).
export interface UploadBridge {
  openFilePickerForAlbum: (albumId: string) => void;
}

interface UploadBridgeState {
  current: UploadBridge | null;
}

function state(): UploadBridgeState {
  return getSharedState<UploadBridgeState>("__uploadBridgeState", () => ({ current: null }));
}

export function registerUploadBridge(bridge: UploadBridge): void {
  state().current = bridge;
}

export function getUploadBridge(): UploadBridge | null {
  return state().current;
}
